import React, { useState } from 'react'
import { Button } from 'semantic-ui-react'
import { CrmModal } from './CrmOverlay'
import { ContactForm } from './ContactForm'

const FORM_ID = 'crm-contact-form-modal'

/**
 * New / edit contact dialog.
 * @param {{ open: boolean, contact?: import('utility/crm/types').CrmContact|null, onClose: () => void,
 *   onSaved: (c: import('utility/crm/types').CrmContact) => void }} props
 */
export const ContactFormModal = ({ open, contact = null, onClose, onSaved }) => {
    const [busy, setBusy] = useState(false)
    return (
        <CrmModal
            open={open}
            onClose={busy ? () => {} : onClose}
            title={contact ? 'Edit contact' : 'New contact'}
            width={600}
            footer={
                <>
                    <Button type="button" onClick={onClose} disabled={busy}>
                        Cancel
                    </Button>
                    <Button type="submit" form={FORM_ID} primary loading={busy} disabled={busy}>
                        {contact ? 'Save changes' : 'Create contact'}
                    </Button>
                </>
            }
        >
            <ContactForm
                contact={contact}
                formId={FORM_ID}
                showButtons={false}
                onBusyChange={setBusy}
                onSaved={saved => {
                    onSaved(saved)
                    onClose()
                }}
            />
        </CrmModal>
    )
}
